import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { compose } from 'recompose';

import { AssignmentRole } from '../../../../utils/internalAssignments';
import { withPayoutReconciliationContextProvider } from '../../../context/PayoutReconciliationContext';
import { PayoutConfig } from '../../../utils/payoutReconciliation';
import CommissionsTable from '../../../components/CommissionsTable';

const InsideSalesCommissions = () => {
  const {
    params: {
      userId: insideSalesId,
    },
  } = useRouteMatch();

  return (
    <CommissionsTable
      userId={insideSalesId}
      payoutsConfig={PayoutConfig[AssignmentRole.INSIDE_SALES]}
    />
  );
};

export default compose(
  withPayoutReconciliationContextProvider,
)(InsideSalesCommissions);
